import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from '@/locales/fr.json';
import en from '@/locales/en.json';
import zh from '@/locales/zh.json';
import ja from '@/locales/ja.json';
import ar from '@/locales/ar.json';
import {
  resolveInitialLanguage,
  applyDocumentLanguage,
  SUPPORTED_LANGUAGE_CODES,
  FALLBACK_LANGUAGE,
} from './language';

const initialLanguage = resolveInitialLanguage();

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      zh: { translation: zh },
      ja: { translation: ja },
      ar: { translation: ar },
    },
    lng: initialLanguage,
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    interpolation: { escapeValue: false },
  });

// Any language change (switcher or otherwise) keeps <html lang/dir> in sync.
i18n.on('languageChanged', applyDocumentLanguage);
applyDocumentLanguage(i18n.language || initialLanguage);

export default i18n;
